import {
    GET_GST_DETAIL_START,
    GET_GST_DETAIL_SUCCESS,
    GET_GST_DETAIL_ERROR,
    STORE_GST_DETAIL_START,
    STORE_GST_DETAIL_SUCCESS,
    STORE_GST_DETAIL_ERROR
} from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
    storeLoading: false,
    storeData: [],
    message: ""
};
  
export default function getGstDetailReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case GET_GST_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case GET_GST_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case GET_GST_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case STORE_GST_DETAIL_START:
        return {
          ...state,
          storeLoading: true,
        };
      case STORE_GST_DETAIL_SUCCESS:
        return {
          ...state,
          storeData: action.payload,
          loading: false,
        };
      case STORE_GST_DETAIL_ERROR:
        return {
          ...state,
          storeLoading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  